"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoMark = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useLogo = require("@cbhq/cds-common/hooks/useLogo");
var _iconStyles = require("./iconStyles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LogoMark = /*#__PURE__*/(0, _react.memo)(({
  size,
  foreground
}) => {
  const _useLogoMark = (0, _useLogo.useLogoMark)({
      size,
      foreground
    }),
    viewBox = _useLogoMark.viewBox,
    width = _useLogoMark.width,
    height = _useLogoMark.height,
    path = _useLogoMark.path,
    color = _useLogoMark.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    "aria-label": "Coinbase logo",
    className: _iconStyles.iconStyles,
    height: height,
    role: "img",
    viewBox: viewBox,
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Coinbase logo"), /*#__PURE__*/_react.default.createElement("path", {
    d: path,
    fill: color
  }));
});
exports.LogoMark = LogoMark;
LogoMark.displayName = 'LogoMark';